import type { FoodAnalysisResponse } from "../domains/food-analysis/food-analysis.model";

type ErrorResponse = {
	error?: string;
};

export class AuthenticationRequiredError extends Error {}

export class FoodAnalysisService {
	private readonly apiUrl: string;

	constructor(apiUrl: string) {
		this.apiUrl = apiUrl.replace(/\/$/, "");
	}

	async analyze(
		image: string,
		accessToken: string,
	): Promise<FoodAnalysisResponse> {
		if (!this.apiUrl) {
			throw new Error("Website chưa được cấu hình địa chỉ AI Worker.");
		}

		const response = await fetch(`${this.apiUrl}/analyze`, {
			method: "POST",
			headers: {
				Authorization: `Bearer ${accessToken}`,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ image }),
		});
		const data = (await response.json()) as FoodAnalysisResponse & ErrorResponse;

		if (response.status === 401) {
			throw new AuthenticationRequiredError(
				data.error || "Phiên đăng nhập đã hết hạn.",
			);
		}
		if (!response.ok) {
			throw new Error(data.error || "Không thể phân tích ảnh.");
		}

		return data;
	}
}

